/* @flow */
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import * as React from 'react';

import Button from 'components/Button';
import OpenAppOrAppStoreButton from 'components/OpenAppOrAppStoreButton';
import Text from 'components/Text';
import Link from 'components/Link';
import Row from 'components/Row';
import isSignedIn from 'user/queries/isSignedInQuery.gql';
import LinkConstants from 'constants/LinkConstants';
import type { State as ReduxState } from 'admin/reducers/adminUpgradePage';
import userAgent from 'lib/currentUserAgent';

import './styles/AdminUpgradeCompleteButton.scss';

type Props = {
  data: ReactApolloData<isSignedIn>,
  reduxState: ReduxState,
};

class AdminUpgradeCompleteButton extends React.Component<Props> {
  render() {
    const { reduxState, data } = this.props;

    if (data.error) {
      // do nothing, we just need to handle (access) it so it doesn't log.
    }

    const { startUrl } = reduxState;
    const backText = 'Back to Remind';
    if (startUrl) {
      return <Button to={startUrl}>{backText}</Button>;
    } else if (userAgent.mobile()) {
      return <OpenAppOrAppStoreButton>{backText}</OpenAppOrAppStoreButton>;
    } else if (data.me) {
      return <Button to={'/classes'}>{backText}</Button>;
    } else {
      return (
        <div>
          <Row size="small">
            <Button href={LinkConstants.SIGN_UP}>Sign Up</Button>
          </Row>
          <Text size="small" element="div">
            Already have an account? <Link to="/log_in">Log in</Link>
          </Text>
        </div>
      );
    }
  }
}

const withData = graphql(isSignedIn);

function mapStateToProps(state) {
  return {
    reduxState: state.adminUpgradePage,
  };
}

export { AdminUpgradeCompleteButton };
// $FlowFixMe
export default withData(connect(mapStateToProps)(AdminUpgradeCompleteButton));
